import React, { useContext } from 'react';
import ValuePropCard from './ValuePropCard';
import { MessageFormat } from '@paypalcorp/worldready';
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react';
// I mage missing for fourth value
const images = [
  '/paypal-ui/illustrations/focused/svg/donation-page-hourglass.svg',
  '/paypal-ui/illustrations/focused/svg/hand-image.svg',
  '/paypal-ui/illustrations/focused/svg/money-down.svg',
  '/paypal-ui/illustrations/focused/svg/show-qrc.svg',
];
const ValueProp = () => {
  const worldReady = useContext(WorldReadyContext);
  const getValuePropContent = () => {
    const path = 'buttonsV3.login.valueProp';
    return [
      {
        heading: new MessageFormat(worldReady, {
          id: `${path}.message1.heading`,
        }).format(),
        body: new MessageFormat(worldReady, {
          id: `${path}.message1.body`,
        }).format(),
      },
      {
        heading: new MessageFormat(worldReady, {
          id: `${path}.message2.heading`,
        }).format(),
        body: new MessageFormat(worldReady, {
          id: `${path}.message2.body`,
        }).format(),
      },
      {
        heading: new MessageFormat(worldReady, {
          id: `${path}.message3.heading`,
        }).format(),
        body: new MessageFormat(worldReady, {
          id: `${path}.message3.body`,
        }).format(),
      },
      {
        heading: new MessageFormat(worldReady, {
          id: `${path}.message4.heading`,
        }).format(),
        body: new MessageFormat(worldReady, {
          id: `${path}.message4.body`,
        }).format(),
      },
    ];
  };
  return (
    <div className="value-prop-msgs-container">
      <div className="value-prop-msgs">
        {getValuePropContent().map((col, index) => (
          <ValuePropCard
            heading={col.heading}
            body={col.body}
            imgSrc={images[index]}
            key={index}
          />
        ))}
      </div>
    </div>
  );
};

export default ValueProp;
